import { useEffect, useState } from 'react';
import { useStatsigClient, useStatsigUser } from '@statsig/react-bindings';

// TODO(RA-4320): remove all related to OldOrderBill when its not needed anymore
export function useShowNewOrderInvoice() {
  const [showNew, setShowNew] = useState<boolean | null>(null);

  const { checkGate } = useStatsigClient();
  const { user: statsigUser } = useStatsigUser();

  useEffect(() => {
    if (statsigUser?.customIDs?.['Country-Partner']) {
      setShowNew(checkGate('aliados_web_printer_new_invoice'));
    }
  }, [statsigUser]);

  return {
    showNewOrderInvoice: showNew,
  };
}
